export const SHOP_STORAGE_KEY = "onboarding_shop";

export const saveShopToLocalStorage = (shop: string): void => {
  if (typeof window !== "undefined") {
    localStorage.setItem(SHOP_STORAGE_KEY, shop);
  }
};

export const getShopFromLocalStorage = (): string | null => {
  if (typeof window !== "undefined") {
    return localStorage.getItem(SHOP_STORAGE_KEY);
  }
  return null;
};

export const removeShopFromLocalStorage = (): void => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(SHOP_STORAGE_KEY);
  }
};
